/**
 * A professional's "Book a Meeting" row is only bookable when their linked
 * Client Director session is active and one-on-one — the same rule the project
 * detail page uses. Mirrors `useProjectBookMeeting`'s `canBookDirect` so the
 * accordion row and the page's section numbering stay in agreement.
 */
export const canBookDirectMeeting = <
    T extends { IsActive?: boolean | null; MeetingType?: string | null },
>(
    session?: T | null,
): session is T =>
    Boolean(session?.IsActive && session.MeetingType === 'one-on-one');
